import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';

const apiKey =
  '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';
const assistId = 'asst_TJWWXXRpqRVOWLM7mb4wMPx6';

async function retrieveAssistantDetails() {
  try {
    const response = await axios.get(
      `https://api.openai.com/v1/assistants/${assistId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiKey}`,
          'OpenAI-Beta': 'assistants=v2'
        },
        maxBodyLength: Infinity
      }
    );
    console.log('Assistant details retrieved:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error retrieving assistant details:', error);
  }
}

async function createThread() {
  try {
    const response = await axios.post(
      'https://api.openai.com/v1/threads',
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiKey}`,
          'OpenAI-Beta': 'assistants=v2'
        },
        maxBodyLength: Infinity
      }
    );
    const createdThreadid = response.data.id;
    console.log('Thread created:', createdThreadid);
    return createdThreadid;
  } catch (error) {
    console.error('Error creating thread:', error);
  }
}

async function createMessage(newMessage, storedThreadid) {
  try {
    const response = await axios.post(
      `https://api.openai.com/v1/threads/${storedThreadid}/messages`,
      JSON.stringify({role: 'user', content: newMessage}),
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiKey}`,
          'OpenAI-Beta': 'assistants=v2'
        },
        maxBodyLength: Infinity
      }
    );
    console.log('Message created:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error creating message:', error);
  }
}

async function addMessageToThread(storedThreadid) {
  try {
    const response = await axios.post(
      `https://api.openai.com/v1/threads/${storedThreadid}/runs`,
      JSON.stringify({assistant_id: assistId}),
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiKey}`,
          'OpenAI-Beta': 'assistants=v2'
        },
        maxBodyLength: Infinity
      }
    );
    console.log('Message added to thread:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error adding message to thread:', error);
  }
}

async function runMessageInThread(runId, storedThreadid) {
  try {
    const response = await axios.get(
      `https://api.openai.com/v1/threads/${storedThreadid}/runs/${runId}`,
      {
        headers: {
          Authorization: `Bearer ${apiKey}`,
          'OpenAI-Beta': 'assistants=v2'
        },
        maxBodyLength: Infinity
      }
    );
    console.log('Message run in thread:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error running message in thread:', error);
  }
}

async function retrieveMessagesInThread(storedThreadid) {
  try {
    const response = await axios.get(
      `https://api.openai.com/v1/threads/${storedThreadid}/messages`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiKey}`,
          'OpenAI-Beta': 'assistants=v2'
        },
        maxBodyLength: Infinity
      }
    );
    if (response.data.data[0]?.content[0]?.text?.value) {
      console.log('Retrieved all messages in thread:', response.data);
      console.log(
        'Last message in thread:',
        response.data.data[0]?.content[0]?.text?.value
      );
      return response.data;
    } else {
      console.log('Content is empty, retrying...');
      await delayFunction(2000);
      return await retrieveMessagesInThread(storedThreadid);
    }
  } catch (error) {
    console.error('Error retrieving messages in thread:', error);
  }
}

function delayFunction(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function runAssistantWorkflow(newMessage, threadId) {
  if (threadId !== '') {
    const message = await createMessage(newMessage, threadId);
    if (message) {
      const runData = await addMessageToThread(threadId);
      if (runData && runData.id) {
        await runMessageInThread(runData.id, threadId);
        await delayFunction(5000);
        const aiResponse = await retrieveMessagesInThread(threadId);
        return {aiResponse, idThread: ''};
      }
    }
  } else {
    await retrieveAssistantDetails();
    const createdThreadId = await createThread();
    if (createdThreadId) {
      AsyncStorage.setItem('threadId', createdThreadId);
      const message = await createMessage(newMessage, createdThreadId);
      if (message) {
        const runData = await addMessageToThread(createdThreadId);
        if (runData && runData.id) {
          await runMessageInThread(runData.id, createdThreadId);
          await delayFunction(5000);
          const aiResponse = await retrieveMessagesInThread(createdThreadId);
          return {aiResponse, idThread: createdThreadId};
        }
      }
    }
  }
  return null;
}

export {runAssistantWorkflow};
